// extracted by mini-css-extract-plugin
export var subtitle = "_8t-2";
export var title = "_8t-0";
export var titleNoWrap = "_8t-1";